import {Tag} from '../../components';

export default function Select({data}) {
    return (
        <>
            <Tag name={data} />
        </>
    );
}
